import React, { Component } from "react";
import { func, bool, string, shape } from "prop-types";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import { selectors as formSelectors } from "reducers/form";

import { get } from "util/i18n";
import { selectors as templateSelectors } from "reducers/template";

import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import { connect } from "react-redux";
import classNames from "classnames";
import ModifyTransaction from "./_confirmations/ModifyTransaction";

class FormActions extends Component {
    static propTypes = {
        onClick: func.isRequired,
        fetching: bool,
        mode: string.isRequired,
        draftsEnabled: bool,
        templatesEnabled: bool,
        transaction: shape({
            idTransactionStatus: bool.isRequired,
        }),
        isEditable: bool,
        isCancellingTransaction: bool.isRequired,
        idForm: bool.isRequired,
        isModalVisible: bool,
        isTemplatesVisibile: bool,
    };

    static defaultProps = {
        fetching: false,
        draftsEnabled: false,
        templatesEnabled: false,
        isEditable: true,
        transaction: {},
        isModalVisible: false,
        isTemplatesVisibile: false,
    };

    state = {
        modifyTransactionConfirm: false,
    };

    getEditButtons = () => {
        const {
            onClick,
            fetching,
            draftsEnabled,
            templatesEnabled,
            mode,
            idForm,
            isModalVisible,
            isTemplatesVisibile,
        } = this.props;

        const label = `forms.${idForm}.send`;
        const defaultLabelText = get("global.send", "");

        if (mode === "edit") {
            return (
                <Col sm={12} md={8} mdOffset={isTemplatesVisibile ? 0 : 2}>
                    <Row className="form-action-btn">
                        {draftsEnabled && (
                            <Col
                                lg={6}
                                className={classNames("col-12", {
                                    "col-xl-4": draftsEnabled,
                                    "col-xl-6": draftsEnabled && !templatesEnabled,
                                })}>
                                <button
                                    type="button"
                                    className="btn btn-outline btn-block"
                                    onClick={() => onClick("saveDraft")}>
                                    <I18n id="forms.saveDraft.link" />
                                </button>
                            </Col>
                        )}

                        {templatesEnabled && (
                            <Col
                                lg={6}
                                // className="col-12 col-xl-4"
                                className={classNames("col-12", {
                                    "col-xl-4": templatesEnabled,
                                    "col-xl-6": !draftsEnabled && templatesEnabled,
                                })}>
                                <button
                                    type="button"
                                    className="btn btn-outline btn-block"
                                    onClick={() => onClick("createTemplate")}
                                    aria-haspopup="dialog"
                                    aria-expanded={isModalVisible}>
                                    <I18n id="forms.saveTemplate.link" />
                                </button>
                            </Col>
                        )}
                        <Col
                            lg={!draftsEnabled || !templatesEnabled ? 6 : 12}
                            // className="col-12 col-xl-4"
                            className={classNames("col-12", {
                                "col-xl-4": draftsEnabled && templatesEnabled,
                                "col-xl-6":
                                    (!draftsEnabled && templatesEnabled) || (draftsEnabled && !templatesEnabled),
                            })}>
                            <Button
                                type="submit"
                                label={label}
                                bsStyle="primary"
                                loading={fetching}
                                defaultLabelText={defaultLabelText}
                                block
                            />
                        </Col>
                    </Row>
                </Col>
            );
        }

        return null;
    };

    getViewButtons = () => {
        const { onClick, fetching, transaction, mode, isCancellingTransaction, isEditable } = this.props;
        const { modifyTransactionConfirm } = this.state;

        if (mode === "view" && transaction) {
            const { idTransactionStatus } = transaction;
            if (idTransactionStatus === "PENDING" || idTransactionStatus === "SCHEDULED") {
                return (
                    <React.Fragment>
                        <Row className="form-action-btn">
                            <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                                {idTransactionStatus === "PENDING" && (
                                    <Button
                                        onClick={() => onClick("signTransaction")}
                                        label="forms.signTransaction.link"
                                        bsStyle="primary"
                                        loading={fetching}
                                        block
                                    />
                                )}

                                <Button
                                    onClick={() => onClick("cancelTransaction")}
                                    label="forms.cancelTransaction.link"
                                    bsStyle="primary"
                                    loading={isCancellingTransaction}
                                    block
                                />

                                {isEditable && (
                                    <Button
                                        onClick={() => this.verifyBeforeModifyTransaction()}
                                        label="forms.modifyTransaction.link"
                                        bsStyle="outline"
                                        loading={isCancellingTransaction}
                                        block
                                    />
                                )}
                                {modifyTransactionConfirm && (
                                    <ModifyTransaction
                                        modifyTransactionConfirm={this.state.modifyTransactionConfirm}
                                        onClose={this.cancelModifyHandleClick}
                                        modifyTransactionClick={() => onClick("modifyTransaction")}
                                        block
                                    />
                                )}
                            </Col>
                        </Row>
                    </React.Fragment>
                );
            }
        }

        return null;
    };

    verifyBeforeModifyTransaction = () => {
        const { onClick, transaction } = this.props;

        if (transaction.signatures.length > 0) {
            this.setState({ modifyTransactionConfirm: true });
        } else {
            onClick("modifyTransaction");
        }
    };

    cancelModifyHandleClick = () => {
        this.setState({ modifyTransactionConfirm: false });
    };

    render() {
        const editButtons = this.getEditButtons();
        const viewButtons = this.getViewButtons();

        return (
            (editButtons || viewButtons) && (
                <Row className="justify-content-center">
                    {editButtons}
                    {viewButtons}
                </Row>
            )
        );
    }
}

const mapStateToProps = (state) => ({
    isCancellingTransaction: formSelectors.getFetching(state) && formSelectors.getIsCancellingTransaction(state),
    isModalVisible: templateSelectors.isCreateModalVisible(state),
});

export default connect(mapStateToProps)(FormActions);
